import React, { useState, useEffect, useContext } from "react";
import SideNav, {
  Toggle,
  Nav,
  NavItem,
  NavIcon,
  NavText,
} from "@trendmicro/react-sidenav";
import "@trendmicro/react-sidenav/dist/react-sidenav.css";
import {
  FaShoppingCart,
  FaEnvelope,
  FaBookOpen,
  FaUsers,
  FaRobot,
  FaSignOutAlt,
  FaChalkboardTeacher,
  FaChartLine,
} from "react-icons/fa";
import { FaHandsHolding } from "react-icons/fa6";
import { ImBooks } from "react-icons/im";
import { MdSpaceDashboard } from "react-icons/md";
import DefaultDp from "../../assets/images/defaultDp.webp";
import {
  getApiKey,
  getUser,
  removeCsrf,
  removeKey,
  removeUser,
} from "../../helpers";
import { useHistory, useLocation } from "react-router-dom";
import { Logout } from "../../services";
import { connect, useDispatch } from "react-redux";
import {
  createErrorAlert,
  deleteCsrf,
  deleteUser,
  getCatalogue,
} from "../../redux/actions";
import { catalogueData } from "../../redux/selectors";
import NavItemTooltip from "../InfoBox/NavItemTooltip.js";
import Context from "../../services/Context.js";

const SideNavComponent = ({
  marginState,
  setMarginState,
  getCatalogue,
  dataCatalogue,
}) => {
  const [paidModules, setPaidModules] = useState([]);

  const history = useHistory();
  const dispatch = useDispatch();
  const { value, updateValue } = useContext(Context);
  const user = JSON.parse(getUser());

  const userCurrency = value?.userCurrency || user?.user_currency;
  const userIsLaw = value?.is_law || user?.is_law;
  const userId = Number(user?.id);
  const canAccessAiStats = Boolean(user?.is_staff);

  useEffect(() => {
    for (let i = 0; i < value?.dataCatalogue?.length; i++) {
      if (value?.dataCatalogue[i]?.is_paid === true) {
        if (
          !paidModules.includes(value?.dataCatalogue[i]?.study_module?.slug)
        ) {
          paidModules.push(value?.dataCatalogue[i]?.study_module?.slug);
        }
      }
    }
  }, [value?.dataCatalogue]);

  useEffect(() => {
  }, [userIsLaw, userCurrency])

  const logout = () => {
    Logout()
      .then(() => {
        removeCsrf();
        removeKey();
        removeUser();
        dispatch(deleteCsrf());
        dispatch(deleteUser());
      })
      .catch((error) => dispatch(createErrorAlert(2, "Error", "Try again", 2)));
    localStorage.clear();
    sessionStorage.clear();
    window.location.assign(`${window.location.origin}/login`);
  };

  const handleSelectedItem = (selected) => {
    if (getApiKey()) {
      if (selected === "join") {
        history.push("/content-creator");
      } else if (selected === "library") {
        history.push("/library");
      } else if (selected === "contact") {
        history.push("/contact-us");
      } else if (selected === "basket") {
        history.push("/shopping-basket");
      } else if (selected === "profile") {
        history.push("/profile");
      } else if (selected === "logout") {
        logout();
      } else if (selected === "dashboard") {
        history.push("/content-creator/my-dashboard");
      } else if (selected === "tutoring") {
        history.push("/boost-your-grades");
      } else if (selected === "study") {
        history.push("/");
      } else if (selected === "ai") {
        history.push(`/aitutor?user_id=${userId}`);
      } else if (selected === "aiStats") {
        if (canAccessAiStats) {
          history.push("/admin/ai-stats");
        }
      } else if (selected === 'career') {
        history.push('/legal-career-advice-uk')
      }
    } else {
      if (selected === "career") {
        dispatch(createErrorAlert(701, '', `
          <div style="padding:20px;border-radius:4px;font-family:Arial,Helvetica,sans-serif;line-height:1.35;">
            <h3 style="margin:0 0 8px;font-size:18px;font-weight:700;">
              Exclusive for UK Law Students <span style="margin-left:6px">🇬🇧</span>
            </h3>
            <p style="margin:0 0 8px;font-size:14px;">
              We’re currently offering <strong>career advice sessions</strong> for law students in the UK only.
            </p>
            <p style="margin:0 0 8px;font-size:14px;">
              <strong>If you’re studying law in the UK, you can book a session to get personalized guidance on applying for legal jobs and building a successful legal career.</strong>
            </p>
            <p style="margin:0;font-size:13px;opacity:0.95;">
              If you’re not a UK law student, this service isn’t available in your region just yet — stay tuned!
            </p>
          </div>
        `, 701));

      } else if (selected === "tutoring") {
        dispatch(createErrorAlert(702, '', `
          <div style="padding:20px;border-radius:4px;font-family:Arial,Helvetica,sans-serif;line-height:1.4;">
            <h3 style="margin:0 0 8px;font-size:18px;font-weight:700;">
              Exclusive for UK Law Students <span style="margin-left:6px;">🇬🇧</span>
            </h3>
            <p style="margin:0 0 8px;font-size:14px;">
              We’re currently offering <strong>tutoring sessions</strong> for law students in the UK only.
            </p>
            <p style="margin:0 0 8px;font-size:14px;">
              If you’re studying law in the UK, you can book a tutoring session to get <strong>personalized guidance on your courseworks and exams in law school.</strong>
            </p>
            <p style="margin:0;font-size:13px;opacity:0.95;">
              If you’re not a UK law student, this service isn’t available in your region just yet — stay tuned!
            </p>
          </div>
        `, 702));

      } else if (selected === "study") {
        dispatch(createErrorAlert(703, '', `
          <div style="padding:14px 18px;border-radius:4px;font-family:Arial,Helvetica,sans-serif;line-height:1.4;font-size:24px;">
            Log in or sign up so we can <strong>match you with study materials that fit your university and degree</strong> saving you time and helping you study smarter.
          </div>
        `, 703));

      } else if (selected === "join") {
        history.push("/content-creator");
      } else if (selected === "contact") {
        history.push("/contact-us");
      } else if (selected === "ai") {
        updateValue({ ...value, requestLoginModal: true, loginRedirectTo: "/aitutor" });
      }
    }
  };

  const handleToggle = (value) => {
    setMarginState(value);
  };

  const handleErrorImage = (e) => {
    e.target.src = DefaultDp;
  };

  return (
    <div
      className="w-16 md:w-20 xl:w-80 sideBarMain ml-3"
      style={{ zIndex: "99999999" }}
    >
      <SideNav
        onSelect={(selected) => handleSelectedItem(selected)}
        onToggle={handleToggle}
        className="sidenavStyle"
        style={{ zIndex: "99999999" }}
      >
        <SideNav.Toggle />
        <SideNav.Nav
          style={{ display: "flex", flexDirection: "column" }}
          className="logoutItem"
        >
          {user?.author && getApiKey() && (
            <NavItem
              eventKey="dashboard"
              className="navItem"
              aria-label="Content Dashboard"
              tabIndex={0}
              role="button"
              onKeyDown={(e) =>
                (e.key === "Enter" || e.key === " ") &&
                handleSelectedItem("dashboard")
              }
            >
              <NavIcon>
                <MdSpaceDashboard
                  aria-hidden="true"
                  style={{ fontSize: "1.75em", margin: "13px 20px" }}
                />
              </NavIcon>
              {!marginState && (
                <NavItemTooltip text="Content Dashboard" aria-hidden="true" />
              )}
              <NavText>Content Dashboard</NavText>
            </NavItem>
          )}

          <NavItem
            eventKey="join"
            className="navItem"
            aria-label="Join Our Team"
            tabIndex={0}
            role="button"
            onKeyDown={(e) =>
              (e.key === "Enter" || e.key === " ") && handleSelectedItem("join")
            }
          >
            <NavIcon>
              <FaUsers
                aria-hidden="true"
                style={{ fontSize: "1.75em", margin: "13px 20px" }}
              />
            </NavIcon>
            {!marginState && (
              <NavItemTooltip text="Join Our Team" aria-hidden="true" />
            )}
            <NavText>Join Our Team</NavText>
          </NavItem>

          <NavItem
            eventKey="ai"
            className="navItem"
            aria-label={'AI Tutor'}
            tabIndex={0}
            onKeyDown={(e) =>
              (e.key === "Enter" || e.key === " ") &&
              handleSelectedItem("ai")
            }
            style={{
              opacity: 1,
              cursor: 'pointer',
            }}
          >
            <NavIcon>
              <FaRobot
                aria-hidden="true"
                style={{ fontSize: "1.75em", margin: "13px 20px" }}
              />
            </NavIcon>
            {!marginState && (
              <NavItemTooltip
                text={'AI Tutor'}
                aria-hidden="true"
              />
            )}
            <NavText>{'AI Tutor'}</NavText>
          </NavItem>

          {canAccessAiStats && (
            <NavItem
              eventKey="aiStats"
              className="navItem"
              aria-label="AI Stats Dashboard"
              tabIndex={0}
              role="button"
              onKeyDown={(e) =>
                (e.key === "Enter" || e.key === " ") &&
                handleSelectedItem("aiStats")
              }
            >
              <NavIcon>
                <FaChartLine
                  aria-hidden="true"
                  style={{ fontSize: "1.75em", margin: "13px 20px" }}
                />
              </NavIcon>
              {!marginState && (
                <NavItemTooltip text="AI Stats Dashboard" aria-hidden="true" />
              )}
              <NavText>AI Stats Dashboard</NavText>
            </NavItem>
          )}

          {((userIsLaw && userCurrency === "UK") || !getApiKey()) && <NavItem
            eventKey="career"
            className="navItem"
            aria-label="Career Advice"
            tabIndex={-1}
          >
            <NavIcon>
              <FaHandsHolding
                aria-hidden="true"
                style={{ fontSize: "1.75em", margin: "13px 20px" }}
              />
            </NavIcon>
            {!marginState && (
              <NavItemTooltip text="Career Advice" aria-hidden="true" />
            )}
            <NavText>Career Advice</NavText>
          </NavItem>}

          {getApiKey() && paidModules.length > 0 && (
            <NavItem
              eventKey="library"
              className="navItem"
              aria-label="My Library"
              tabIndex={0}
              role="button"
              onKeyDown={(e) =>
                (e.key === "Enter" || e.key === " ") &&
                handleSelectedItem("library")
              }
            >
              <NavIcon>
                <FaBookOpen
                  aria-hidden="true"
                  style={{ fontSize: "1.75em", margin: "13px 20px" }}
                />
              </NavIcon>
              {!marginState && (
                <NavItemTooltip text="My Library" aria-hidden="true" />
              )}
              <NavText>My Library</NavText>
            </NavItem>
          )}

          {((userIsLaw && userCurrency === "UK") || !getApiKey()) && (
            <NavItem
              eventKey="tutoring"
              className="navItem"
              aria-label="Tutoring"
              tabIndex={0}
              role="button"
              onKeyDown={(e) =>
                (e.key === "Enter" || e.key === " ") &&
                handleSelectedItem("tutoring")
              }
            >
              <NavIcon>
                <FaChalkboardTeacher
                  aria-hidden="true"
                  style={{ fontSize: "1.75em", margin: "13px 20px" }}
                />
              </NavIcon>
              {!marginState && (
                <NavItemTooltip text="Tutoring" aria-hidden="true" />
              )}
              <NavText>Tutoring</NavText>
            </NavItem>
          )}

          {(
            <NavItem
              eventKey="study"
              className="navItem"
              aria-label="Study Materials"
              tabIndex={0}
              role="button"
              onKeyDown={(e) =>
                (e.key === "Enter" || e.key === " ") &&
                handleSelectedItem("study")
              }
            >
              <NavIcon>
                <ImBooks
                  aria-hidden="true"
                  style={{ fontSize: "1.75em", margin: "13px 20px" }}
                />
              </NavIcon>
              {!marginState && (
                <NavItemTooltip text="Study Materials" aria-hidden="true" />
              )}
              <NavText>Study Materials</NavText>
            </NavItem>
          )}

          <NavItem
            eventKey="contact"
            className="navItem"
            aria-label="Contact Us"
            tabIndex={0}
            role="button"
            onKeyDown={(e) =>
              (e.key === "Enter" || e.key === " ") &&
              handleSelectedItem("contact")
            }
          >
            <NavIcon>
              <FaEnvelope
                aria-hidden="true"
                style={{ fontSize: "1.75em", margin: "13px 20px" }}
              />
            </NavIcon>
            {!marginState && (
              <NavItemTooltip text="Contact Us" aria-hidden="true" />
            )}
            <NavText>Contact Us</NavText>
          </NavItem>

          {(
            <NavItem
              eventKey="basket"
              className="navItem"
              aria-label={user?.user_currency === "UK" ? "Basket" : "Cart"}
              tabIndex={0}
              role="button"
              onKeyDown={(e) =>
                (e.key === "Enter" || e.key === " ") &&
                handleSelectedItem("basket")
              }
            >
              <NavIcon>
                <FaShoppingCart
                  aria-hidden="true"
                  style={{ fontSize: "1.75em", margin: "13px 20px" }}
                />
              </NavIcon>
              {!marginState && (
                <NavItemTooltip
                  text={user?.user_currency === "UK" ? "Basket" : "Cart"}
                  aria-hidden="true"
                />
              )}
              <NavText>
                {user?.user_currency === "UK" ? "Basket" : "Cart"}
              </NavText>
            </NavItem>
          )}

          {getApiKey() && (
            <NavItem
              eventKey="profile"
              className="sideBarProfileItem navItem"
              aria-label="Profile"
              tabIndex={0}
              role="button"
              onKeyDown={(e) =>
                (e.key === "Enter" || e.key === " ") &&
                handleSelectedItem("profile")
              }
            >
              <NavIcon>
                <img
                  src={user?.image || DefaultDp}
                  alt={user?.name || "User profile"}
                  onError={handleErrorImage}
                  className="sideBarProfileImage"
                />
              </NavIcon>
              {!marginState && (
                <NavItemTooltip text="Profile" aria-hidden="true" />
              )}
              <NavText>Profile</NavText>
            </NavItem>
          )}

          {getApiKey() && (
            <NavItem
              eventKey="logout"
              className="sideBarLogoutItem navItem"
              aria-label="Logout"
              tabIndex={0}
              role="button"
              onKeyDown={(e) =>
                (e.key === "Enter" || e.key === " ") &&
                handleSelectedItem("logout")
              }
            >
              <NavIcon>
                <FaSignOutAlt
                  aria-hidden="true"
                  style={{ fontSize: "1.75em", margin: "13px 20px" }}
                />
              </NavIcon>
              {!marginState && (
                <NavItemTooltip text="Logout" aria-hidden="true" />
              )}
              <NavText>Logout</NavText>
            </NavItem>
          )}
        </SideNav.Nav>
      </SideNav>
    </div>
  );
};

const mapStateToProps = (state) => ({
  dataCatalogue: catalogueData(state),
});
const mapDispatchToProps = (dispatch) => ({
  getCatalogue: (id) => dispatch(getCatalogue(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SideNavComponent);
